import { SignupState } from '../interfaces/signup.interfaces';
import { User } from 'src/app/shared/models/user.model';

/**
 * Construye el payload del usuario desde el estado de signup.
 * Compartido entre pep-selection-step (no PEP) y pep-declaration-step (sí PEP).
 */
export function buildUserPayload(
  state: SignupState,
  documentType: 'chile' | 'venezuela' | 'other',
  politicamenteExpuesto: boolean
): User {
  const ocrData = state.ocrData;
  const formData = state.formData;
  const s3Keys = state.s3Keys;

  const isChile = documentType === 'chile';
  let tipoId: string;
  let numeroId: string;

  if (isChile) {
    tipoId = 'RUT';
    numeroId = ocrData?.documentNumberClean || ocrData?.documentNumber || '';
  } else {
    tipoId = 'VE';
    const prefijo = ocrData?.documentPrefix || 'V';
    const numero = ocrData?.documentNumberClean || ocrData?.documentNumber || '';
    numeroId = `${prefijo}${numero}`;
  }

  return {
    email: formData?.email || '',
    nombre: ocrData?.firstName || '',
    apellidos: ocrData?.lastName || '',
    tipoId,
    numeroId,
    prefijoTelefono: formData?.phoneCode || '',
    telefono: formData?.phone || '',
    sexo: ocrData?.gender || '',
    fechaNacimiento: ocrData?.fechaNacimientoISO || '',
    direccion: ocrData?.address || '',
    profesion: ocrData?.profession || '',
    paisResidencia: ocrData?.countryAddress || '',
    ciudadResidencia: ocrData?.cityAddress || '',
    nacionalidad: ocrData?.nationality || '',
    volumenMensual: ocrData?.volumenMensual || '',
    politicamenteExpuesto,
    cognitoId: state.cognitoId,
    tipoUsuarioID: 0,
    selfie: s3Keys?.selfie || '',
    fotoIdfrontal: s3Keys?.documentFront || '',
    fotoIdPosterior: s3Keys?.documentBack || undefined,
  };
}
